import React, { type FC, Fragment, type ReactNode } from 'react'
import { Box, Divider, type SxProps, type Theme } from '@mui/material'

import type { ReadonlyPropsWithChildren } from '../utils'

export const Section: FC<ReadonlyPropsWithChildren<{ width?: number }>> = ({ width, children }) => <Box sx={{ width }}>{children}</Box>

const dividerStyle: SxProps<Theme> = { my: 4, borderWidth: 2 }

export const Sections: FC<{ children: readonly ReactNode[] }> = ({ children }) => (
    <>
        {children.map((child, k) => (
            <Fragment key={k}>
                {k > 0 && <Divider variant="fullWidth" sx={dividerStyle} />}
                {child}
            </Fragment>
        ))}
    </>
)
